/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 興津の定数クラス
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */

export default class {
  /**
   * フラグ : OFF
   */
  static get FLG_OFF() {
    return '0'
  }
  /**
   * フラグ : ON
   */
  static get FLG_ON() {
    return '1'
  }
}



// WEBPACK FOOTER //
// ./src/constants/CommonConst.js